/* tp-delivery.js -- postcode checker and run-length calculator. Generated helper, plain JS, no build step.
   Data: <script type="application/json" id="tp-zones"> rendered once by snippets/tp-zones-data.liquid.
   Re-hydrates after Horizon morphs the cart drawer (cart:update) because scripts inside morphed HTML do not run. */
(function () {
  'use strict';
  var KEY = 'tp_postcode';
  var zones = null;
  function data() {
    if (zones) return zones;
    var el = document.getElementById('tp-zones');
    if (!el) return null;
    try { zones = JSON.parse(el.textContent); } catch (e) { zones = null; }
    return zones;
  }
  /* Whole dollars print bare ("$65"); anything with cents prints both digits ("$86.80").
     toLocaleString alone drops the trailing zero, so a $86.80 shortfall read "$86.8" in the
     cart drawer. Rounds through cents first: 100 - 13.2 is not always exact in binary. */
  function money(n) {
    var c = Math.round(Number(n) * 100);
    var d = c % 100 === 0 ? 0 : 2;
    return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function tierOf(pc) {
    var d = data(); if (!d) return null;
    var t = d.postcodes[pc]; if (!t) return null;
    for (var i = 0; i < d.tiers.length; i++) if (d.tiers[i].tier === t) return d.tiers[i];
    return null;
  }
  function remember(pc) { try { localStorage.setItem(KEY, pc); } catch (e) {} }
  function recall() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }

  function message(pc, ctx, subtotalCents) {
    var d = data();
    if (!/^\d{4}$/.test(pc)) return { html: 'Enter a four-digit postcode.', ok: false };
    var z = tierOf(pc);
    if (!z) {
      return { html: 'We don\u2019t deliver to ' + pc + ' yet. Email <a href="mailto:' + d.email + '">' + d.email + '</a> and we will let you know if we reach you later.', ok: false };
    }
    var sub = Number(subtotalCents || 0) / 100;
    var parts = [];
    if (ctx === 'cart' && sub > 0) {
      if (z.min && sub < z.min) {
        parts.push(money(z.min - sub) + ' more to reach the ' + money(z.min) + ' minimum for ' + z.name + '.');
        parts.push('Delivery to ' + z.name + ' is ' + money(z.fee) + ', free over ' + money(z.free) + '.');
      } else if (sub >= z.free) {
        parts.push('Delivery to ' + z.name + ': free (orders over ' + money(z.free) + ').');
      } else {
        parts.push('Delivery to ' + z.name + ': ' + money(z.fee) + '.');
        parts.push('Free over ' + money(z.free) + ' \u2014 ' + money(z.free - sub) + ' away.');
      }
    } else {
      parts.push(z.name + ': delivery ' + money(z.fee) + (z.min ? ', minimum order ' + money(z.min) : '') + ', free over ' + money(z.free) + '.');
    }
    // Behind the same TP_PICKER_LIVE as the four strings in build-theme-content.mjs; live by default.
    parts.push((ctx === 'cart' ? 'Choose your delivery day below, before you pay.' : 'You choose your delivery day in the cart, before you pay.'));
    return { html: parts.join(' '), ok: true };
  }

  /* Pickeasy's own postcode field. On the cart it is the ONE place the customer types a postcode
     (two Pickeasy locations: the postcode picks the schedule). Read by id, never written to. */
  var PE_ZIP = 'delivery-location-zip';
  var PE_CHECK = 'delivery-location-search';
  var FALLBACK_MS = 8000;

  /* THE NEAREST PICKEASY FIELD, NOT THE FIRST. The cart page also carries the drawer's markup,
     so Pickeasy's widget -- and its id -- appears twice. getElementById returned the closed
     drawer's empty field and the cart page's line never filled (found 17 Sep 2026, by the gate
     typing into the visible field and reading nothing back). Walk up from the checker to the
     first ancestor that contains a Pickeasy field: on /cart that is the page's own, in the drawer
     it is the drawer's. */
  function zipFor(root) {
    for (var n = root.parentElement; n; n = n.parentElement) {
      var z = n.querySelector('input#' + PE_ZIP);
      if (z) return z;
    }
    return null;
  }
  /* ORDER ON THE CART (Jacob, 17 Sep 2026): Pickeasy's postcode field -> our fee and shortfall line
     -> Pickeasy's date question. Our checker renders above Pickeasy's whole widget, which read
     backwards: the answer before the question. So a MIRROR of the line is kept inside Pickeasy's
     widget, immediately before its date picker, and our own copy of the line is hidden.
     A mirror, not a move: Pickeasy re-renders its own DOM, and a node it removes must be one we
     can recreate, not our only copy. Every write below happens only if something differs, because
     this runs from a MutationObserver (see the 17 Sep freeze above). If Pickeasy's layout is not
     as expected, nothing is mirrored and our own line stays where it is. */
  function placeMirror(root, out, z, html) {
    var slots = z.closest('#order-slots');
    var picker = slots && slots.querySelector('pickeasy-slot-picker');
    if (!slots || !picker || picker.parentElement !== slots) {
      if (out.style.display === 'none') out.style.display = '';
      return;
    }
    var m = null;
    for (var i = 0; i < slots.children.length; i++) if (slots.children[i].classList.contains('tp-pc-mirror')) { m = slots.children[i]; break; }
    if (!m) {
      m = document.createElement('p');
      m.className = 'tp-pc-mirror';
      m.setAttribute('aria-live', 'polite');
    }
    if (m.parentElement !== slots || m.nextElementSibling !== picker) slots.insertBefore(m, picker);
    if (m.innerHTML !== html) m.innerHTML = html;
    if (out.style.display !== 'none') out.style.display = 'none';
  }

  function syncCartFromPickeasy(changed) {
    document.querySelectorAll('[data-tp-postcode-check][data-context="cart"]').forEach(function (r) {
      if (!r._tpFromPickeasy) return;
      if (changed && zipFor(r) !== changed) return;
      r._tpFromPickeasy(changed ? String(changed.value || '') : undefined);
    });
  }
  /* Delegated and in the capture phase, so it survives Pickeasy re-rendering its input and
     Horizon morphing the cart drawer: neither replaces the document. */
  ['input', 'change', 'keyup'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target && e.target.id === PE_ZIP) syncCartFromPickeasy(e.target);
    }, true);
  });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('#' + PE_CHECK) : null;
    if (t) setTimeout(function () { syncCartFromPickeasy(); }, 50);
  }, true);

  function hydrateCheck(root) {
    if (root.dataset.tpHydrated === '1') return;
    root.dataset.tpHydrated = '1';
    var input = root.querySelector('.tp-pc__input');
    var btn = root.querySelector('.tp-pc__button');
    var out = root.querySelector('.tp-pc__out');
    var ctx = root.dataset.context;
    if (ctx === 'cart') {
      var row = root.querySelector('.tp-pc__row');
      var label = root.querySelector('.tp-pc__label');
      /* typed: the value from the event that just happened. Without it, the value is read from
         the field -- but Pickeasy re-renders the field after a search, and a mutation-driven read
         in the middle of that can see an empty box. So the last postcode seen from a real event
         is kept, and only a real event can clear it. */
      root._tpFromPickeasy = function (typed) {
        var z = zipFor(root);
        if (!z) return false;
        if (typed !== undefined) root._tpLastPc = typed;
        /* Pickeasy's field exists: it is the only question asked. Hide ours, even if the
           fallback had shown it because Pickeasy loaded late. */
        if (root.dataset.tpSource !== 'pickeasy') root.dataset.tpSource = 'pickeasy';
        if (row.style.display !== 'none') row.style.display = 'none';
        if (label.style.display !== 'none') label.style.display = 'none';
        var fromField = String(z.value || '').replace(/[^0-9]/g, '').slice(0, 4);
        var pc = fromField.length === 4 ? fromField : String(root._tpLastPc || '').replace(/[^0-9]/g, '').slice(0, 4);
        /* WRITE ONLY WHAT CHANGED. This function runs from a MutationObserver, and assigning
           innerHTML -- even the same string -- is itself a mutation. On 17 Sep 2026 that fed the
           observer back into this function forever and froze the cart drawer the moment Pickeasy
           touched its DOM: a tap on Pickeasy's field, then keyboard input that never arrived.
           Found because the gate's typing timed out, not because anything reported an error. */
        var html = '', ok = false;
        if (pc.length === 4) {
          remember(pc);
          var m = message(pc, ctx, root.dataset.subtotal);
          html = m.html; ok = m.ok;
        }
        if (out.innerHTML !== html) out.innerHTML = html;
        if (root.classList.contains('tp-pc--ok') !== ok) root.classList.toggle('tp-pc--ok', ok);
        placeMirror(root, out, z, html);
        return true;
      };
      btn.addEventListener('click', run);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      if (!root._tpFromPickeasy()) {
        setTimeout(function () {
          if (!root.isConnected || root._tpFromPickeasy()) return;
          /* Pickeasy's field never appeared. Losing the fee and the shortfall line is worse
             than asking for a postcode, so show our own input. */
          root.dataset.tpSource = 'own';
          row.style.display = '';
          label.style.display = '';
          out.style.display = '';
          var saved = recall();
          if (saved && !input.value) { input.value = saved; run(); }
        }, FALLBACK_MS);
      }
      return;
    }
    function run() {
      var pc = (input.value || '').replace(/\D/g, '').slice(0, 4);
      input.value = pc;
      if (pc.length === 4) remember(pc);
      var m = message(pc, ctx, root.dataset.subtotal);
      out.innerHTML = m.html;
      root.classList.toggle('tp-pc--ok', m.ok);
    }
    btn.addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    var saved = recall();
    if (saved && !input.value) { input.value = saved; run(); }
  }

  function hydrateCalc(root) {
    if (root.dataset.tpHydrated === '1') return;
    root.dataset.tpHydrated = '1';
    var min = Number(root.dataset.min), max = Number(root.dataset.max);
    var input = root.querySelector('.tp-calc__input');
    var btn = root.querySelector('.tp-calc__button');
    var out = root.querySelector('.tp-calc__out');
    function option(len, spacing, label, note) {
      var n = Math.ceil(len / spacing);
      if (n < 1) n = 1;
      var actual = Math.round((len / n) * 100) / 100;
      var el = document.createElement('div');
      el.className = 'tp-calc__option';
      el.innerHTML = '<div><strong>' + n + ' plant' + (n === 1 ? '' : 's') + ' at ' + actual + ' m</strong><small>' + label + ' \u2014 ' + note + '</small></div>';
      var add = document.createElement('button');
      add.type = 'button'; add.className = 'button tp-calc__add'; add.textContent = 'Add ' + n + ' to cart';
      add.addEventListener('click', function () { addToCart(n, add); });
      el.appendChild(add);
      return el;
    }
    function run() {
      var len = Number(input.value);
      out.innerHTML = '';
      if (!(len > 0)) { out.innerHTML = '<p class="tp-calc__err">Enter the length of the run in metres.</p>'; return; }
      out.appendChild(option(len, min, 'formal hedge', 'closes fastest'));
      if (max > min) out.appendChild(option(len, max, 'open screen', 'more room per plant, slower to close'));
    }
    function addToCart(n, source) {
      var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
      var qty = form && form.querySelector('input[name="quantity"]');
      var atc = form && (form.querySelector('[ref="addToCartButton"]') || form.querySelector('button[type="submit"]'));
      if (!form || !qty || !atc) { source.textContent = 'Set the quantity above to ' + n; return; }
      var max = Number(qty.getAttribute('max'));
      if (max && n > max) { source.textContent = 'Only ' + max + ' available \u2014 set quantity above'; return; }
      qty.value = n;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      atc.click();
    }
    btn.addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
  }

  function hydrateAll() {
    document.querySelectorAll('[data-tp-postcode-check]').forEach(hydrateCheck);
    document.querySelectorAll('[data-tp-quantity-calc]').forEach(hydrateCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrateAll); else hydrateAll();
  document.addEventListener('cart:update', function () { setTimeout(hydrateAll, 50); });
  /* Also re-sync the cart checkers: Pickeasy renders its postcode field AFTER our hydration, and
     no input event fires for a field that simply appears (with a value restored, for example). */
  /* Mutations made inside our own checkers are ignored outright, as a second guard against the
     observer feeding itself: only the rest of the page (Pickeasy, Horizon's drawer) can trigger
     a re-sync. */
  new MutationObserver(function (records) {
    var foreign = false;
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (!el || !el.closest || !el.closest('[data-tp-postcode-check], [data-tp-quantity-calc], .tp-pc-mirror')) { foreign = true; break; }
    }
    if (!foreign) return;
    hydrateAll();
    syncCartFromPickeasy();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
